import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children, socket }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      verifyToken();
    } else {
      setLoading(false);
    }
  }, [token]);

  const verifyToken = async () => {
    try {
      const response = await api.get('/api/auth/me');
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem('token');
      setToken(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    try {
      const response = await api.post('/api/auth/login', { username, password });
      const { token, user } = response.data;
      
      localStorage.setItem('token', token);
      setToken(token);
      setUser(user);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      return true;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    delete api.defaults.headers.common['Authorization'];
  };

  // Onda 43: a lista de funcionalidades vem do backend, já cruzada com a vertical
  // desta instalação e com o perfil do usuário. É o mesmo catálogo que barra as
  // requisições, então o menu nunca oferece uma tela que a rota vai recusar.
  const can = (feature) => Array.isArray(user?.features) && user.features.includes(feature);

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated: !!token,
    can,
    vertical: user?.vertical || null,
    // Onda 154: a instalação cobra ticket? No estacionamento, sempre; em clube e condomínio, só com a
    // chave "cobrança habilitada" ligada pelo superadministrador.
    cobranca: user?.vertical === 'estacionamento' || user?.cobranca_habilitada === true,
    // Onda 123: qual cliente é esta instalação ('' quando não configurado).
    clienteNome: String(user?.client_name || '').trim(),
    isSuperadmin: user?.role === 'superadmin',
    socket
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};
